

export const parcelList = [
            {
                parcelType : 'LIGHT-X', 
                parcelVersion: ['5'],
                description : 'Emballage souple, fermeture zip',
                imageName : 'light-zip.png',
                scale : 1.5,
                translateX : '3%',
                translateY : '2%',
            },
            {
                parcelType : 'LIGHT-X',
                parcelVersion: ['2','3','4'],
                description : 'Emballage souple, fermeture roulée',
                imageName : 'light-x.png',
                scale : 1.5,
                translateX : '0%',
                translateY : '2%',
            },
            {
                parcelType : 'BOX',
                parcelVersion: [],
                description : 'Boîte rigide',
                imageName : 'box.png',
                scale : 1.25,
                translateX : '-1.25%',
                translateY : '-2%',
            },
            {
                parcelType : 'SLEEVE', //scellé carton v2
                parcelVersion : ['2'],
                description : 'Enveloppe carton, fermeture scellé carton',
                imageName : 'sleeve-v2.png',
                scale : 1.18,
                translateX : '0%',
                translateY : '-2%',
            },
            {
                parcelType : 'SLEEVE', //languette carton v1
                parcelVersion : ['1'],
                description : 'Enveloppe carton, fermeture languette carton',
                imageName : 'sleeve-v1.png',
                scale : 1.2,
                translateX : '4%',
                translateY : '1%',
            },
    ];